var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":"","small":"","color":"error"},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v("cancel")]),_vm._v("\n"+_vm._s(_vm.translater.__('Cancel'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }